import { BaseAppChannel } from "./base-app-channel";
import { clientWindow } from "./dom";
import {
  getStorageClientInfo,
  getStorageToken,
  getStorageUid,
  getStorageUserInfo,
} from "./storage";
import { getUriQuery } from "./url";

/**
 * 获取客户端信息
 * @returns 客户端信息
 */
export const getClientInfo = async () => {
  let clientInfo = undefined;
  clientInfo = getStorageClientInfo();
  if (clientInfo) {
    return clientInfo;
  }
  if (clientWindow?.yoofinds) {
    return clientWindow?.yoofinds?.client_info;
  }
  return await BaseAppChannel.getClientInfoAsync();
};

/**
 * 获取token
 * @returns token
 */
export const getToken = async () => {
  let token = undefined;

  // if (NEXT_PUBLIC_LOCAL_ENV === "local") {
  //   return NEXT_PUBLIC_TOKEN || "";
  // }

  token = getStorageToken();
  if (token) {
    return token;
  }

  if (clientWindow?.yoofinds?.token) {
    return clientWindow?.yoofinds?.token;
  }

  token = getUriQuery(clientWindow?.location?.search || "", ["token"])
    ?.token as string;
  if (token) {
    return token;
  }

  return await BaseAppChannel.getTokenAsync();
};

/**
 * 获取用户信息
 * @returns 用户信息
 */
export const getUserInfo = async () => {
  let userInfo = undefined;
  userInfo = getStorageUserInfo();
  if (userInfo) {
    return userInfo;
  }
  if (clientWindow?.yoofinds) {
    return clientWindow?.yoofinds?.user_info;
  }
  return await BaseAppChannel.getUserInfoAsync();
};

/**
 * 获取用户uid
 * @returns 用户uid
 */
export const getUid = async () => {
  let uid = undefined;
  uid = getStorageUid();
  if (uid) {
    return uid;
  }
  if (clientWindow?.yoofinds) {
    return clientWindow?.yoofinds?.uid;
  }
  uid = getUriQuery(clientWindow?.location?.search || "", ["uid"])
    ?.uid as string;
  if (uid) {
    return uid;
  }
  return await BaseAppChannel.getUidAsync();
};
